<template>
  <div class="w-full h-auto flex flex-col justify-center items-center">
    <Todo />
  </div>
</template>
<script>
import Todo from "@/components/todo.vue";

export default {
  components: {
    Todo
  }
};
</script>
